import { render } from "./cookiesPrivacy.vue?vue&type=template&id=a879eaf8&scoped=true&ts=true"
import script from "./cookiesPrivacy.vue?vue&type=script&lang=ts"
export * from "./cookiesPrivacy.vue?vue&type=script&lang=ts"

import "./cookiesPrivacy.vue?vue&type=style&index=0&id=a879eaf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a879eaf8"]])

export default __exports__